import PlaceBaseSource from './PlaceBaseSource';

export default class PlacePointsSource extends PlaceBaseSource {
  /** @var {String} id */
  static id = 'place-points';
}
